import { HTTP, authHeader } from './http-service';

class SchemeUserService {
  get(schemeId) {
    return HTTP.get(`/schemeUser/${schemeId}/`, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  byEmail(schemeId, accountId) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';

    return HTTP.post(`/schemeUser/${schemeId}/byemail?accountId=${accountId}`, `"${accountId}"`, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  invite(payload) {
    return HTTP.post(`/schemeUser/invite/`, payload, { headers: authHeader() }).then((response) => {
      return response.data;
    });
  }

  resendInvite(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.post(
      `/schemeUser/sendInvite?email=${payload.accountId}`,
      `"${payload.accountId}"`,
      {
        headers,
      }
    ).then((response) => {
      return response.data;
    });
  }

  disable(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.put(`/schemeUser/disable?email=${payload.accountId}`, `"${payload.accountId}"`, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  enable(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.put(`/schemeUser/enable?email=${payload.accountId}`, `"${payload.accountId}"`, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }

  reset(payload) {
    const headers = authHeader();
    headers['Content-Type'] = 'text/json';
    return HTTP.put(`/schemeUser/reset`, payload, {
      headers,
    }).then((response) => {
      return response.data;
    });
  }
}

export default new SchemeUserService();
